/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';
import { theme } from 'theme/theme';
import { TallerBase } from 'utils/models/types';
import Paginacion from '../Paginacion/Paginacion';
import CardTaller from './CardTaller';
import PageContainer from 'components/PageContainer/PageContainer';
import { anchoMax } from 'utils/constants';
interface GrillaProps {
  titulo: string;
  textoBoton: string;
  elementos: any[];
  path: string;
  mostrarFechas: boolean;
}

const GrillaTalleres = ({ titulo, elementos, textoBoton, mostrarFechas, path }: GrillaProps) => {
  const [paginaActual, setPaginaActual] = useState(1);
  const elementosPorPagina = 6;
  const hayTalleres = elementos.length > 0;

  // Maneja cambio de página
  const handleChange = (e: any, value: React.SetStateAction<number>) => {
    setPaginaActual(value);
  };

  return (
    <PageContainer>
      <Box maxWidth={anchoMax} textAlign="left" margin="auto">
        <Typography variant="h3" mb="25px" color={theme.palette.primary.main} fontSize="1.5rem">
          {titulo}
        </Typography>
      </Box>
      {hayTalleres ? (
        <>
          <ImageList
            className="grilla"
            sx={{
              maxWidth: anchoMax,
              marginX: 'auto',
              my: '30px',
              gridTemplateColumns: {
                xs: 'repeat(1, 1fr)!important',
                md: 'repeat(2, 1fr)!important',
                lg: 'repeat(3, 1fr)!important',
                xl: 'repeat(4, 1fr)!important',
              },
            }}
            gap={30}
          >
            {elementos.map(({ Id, Nombre, AficheUrl }: TallerBase) => {
              return (
                <ImageListItem sx={{ margin: 'auto', height: '100%!important' }} key={Id}>
                  <CardTaller
                    id={Id}
                    img={AficheUrl.toString()}
                    titulo={Nombre}
                    path={path}
                    textoBoton={textoBoton}
                    mostrarFechas={mostrarFechas}
                  />
                </ImageListItem>
              );
            })}
          </ImageList>

          <Paginacion
            elementos={elementos}
            elementosPorPag={elementosPorPagina}
            paginaActual={paginaActual}
            handleChange={handleChange}
          />
        </>
      ) : (
        <Box maxWidth={anchoMax} mx="auto" my={4} p={3} textAlign="center">
          <Typography variant="body1" color="text.secondary">
            No hay talleres disponibles por el momento.
          </Typography>
        </Box>
      )}
    </PageContainer>
  );
};

export default GrillaTalleres;
